export const newsletterEvents = {
  newsletter_modal_success: "newsletter_modal_success" as const,
  newsletter_modal_error: "newsletter_modal_error" as const,
  newsletter_modal_skip: "newsletter_modal_skip" as const,
  newsletter_modal_open: "newsletter_modal_open" as const,
};
export type NewsletterEvents = typeof newsletterEvents;
